import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  IconButton,
  CardMedia,
} from "@mui/material";
import { removeComma, toMoney } from "../../util/Utils";
import { Box, TextField } from "@mui/material";
import { UseUserswallet } from "./UseUserswallet";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSnackbar } from "notistack";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function UserWalletDetails(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { getWalletByMobile, AddWallet, SubtractWallet, getOffersList } =
    UseUserswallet();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [offerRes, setOfferRes] = useState();
  const [detailRes, setDetailRes] = useState();
  const [selectOffer, setSelectOffer] = useState();
  const [state, setState] = useState({
    id: undefined,
    cost: 0,
    description: undefined,
    offerid: undefined,
  });
  const [opration, setOpration] = useState({
    show: false,
    add: false,
    subtract: false,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (opration.show) {
      setSelectOffer();
      setState({
        id: undefined,
        cost: 0,
        description: undefined,
        offerid: undefined,
      });
    }
  }, [opration.show]);

  useEffect(() => {
    if (props.openDetail.mobile) {
      setProgress(true);
      getOffersList((Wallets) => {
        setOfferRes(Wallets);
      });
      getWalletByMobile(props.openDetail.mobile, (callback) => {
        setDetailRes(callback);
      });
    }
  }, [props.openDetail]);

  return (
    <Dialog
      PaperProps={{
        elevation: 1,
      }}
      fullWidth
      // maxWidth="{opration.show ? "sm" : "sm"}"
      open={props.openDetail.show}
      onClose={() => props.setOpenDetail({ ...props.openDetail, show: false })}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle color="secondary" id="alert-dialog-title">
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!opration.show ? (
            <Typography color="secondary" variant="subtitle2">
              جزئیات کیف پول کاربر
            </Typography>
          ) : (
            <Typography color="secondary" variant="subtitle2">
              {opration.add
                ? "درخواست افزودن به کیف پول"
                : " درخواست کسر از کیف پول"}
            </Typography>
          )}
          {!opration.show ? (
            <IconButton
              onClick={() => {
                props.setOpenDetail({ ...props.openDetail, show: false });
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => {
                setOpration({ ...opration, show: false });
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {!opration.show ? (
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="نام کاربر"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  detailRes && detailRes.fullName ? detailRes.fullName : ""
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="موبایل"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={detailRes && detailRes.mobile ? detailRes.mobile : ""}
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="مبلغ کیف پول"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  detailRes && detailRes.cost ? toMoney(detailRes.cost) : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="به‌روزرسانی"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  detailRes && detailRes.shamsiLastUpdate
                    ? detailRes.shamsiLastUpdate
                    : ""
                }
                variant="filled"
              />
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              gridColumn="span 12"
            >
              <Button
                color="secondary"
                sx={{ mr: 2 }}
                variant="contained"
                onClick={() => {
                  setOpration({ show: true, add: true, subtract: false });
                }}
              >
                افزودن به کیف پول
              </Button>
              <Button
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setOpration({ show: true, add: false, subtract: true });
                }}
              >
                کسر از کیف پول
              </Button>
            </Box>
          </Box>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            {!opration.subtract && (
              <Box
                sx={{ alignItems: "baseline" }}
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gap={1}
              >
                {offerRes &&
                  offerRes.map((m, i) => {
                    return (
                      <Box key={i} gridColumn="span 4">
                        <CardMedia
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            setState({
                              ...state,
                              id: detailRes.id,
                              cost: m.cost1,
                              offerid: m.id,
                            });
                            setSelectOffer(m);
                          }}
                          // sx={{ width: "150px" }}
                          component="img"
                          alt="green iguana"
                          image={m.image}
                        />
                      </Box>
                    );
                  })}
              </Box>
            )}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="مبلغ"
                size="small"
                sx={{
                  width: "50%",
                  mr: 1,
                  input: {
                    direction: "rtl",
                  },
                }}
                type="text"
                value={state.cost ? toMoney(state.cost) : ""}
                onChange={(evt) => {
                  const sanitizedValue = evt.target.value.replace(
                    /[^0-9.]/g,
                    ""
                  );
                  setState({
                    ...state,
                    id: detailRes.id,
                    cost: removeComma(sanitizedValue),
                    offerid: undefined,
                  });
                }}
                variant="outlined"
              />
              {!opration.subtract && selectOffer && selectOffer.cost2 ? (
                <Typography color="secondary" variant="subtitle2">
                  مبلغ {toMoney(selectOffer.cost2)} تومان اعتبار اضافه
                </Typography>
              ) : (
                ""
              )}
            </Box>
            <TextField
              fullWidth
              multiline
              rows={3}
              id="outlined-basic"
              label="توضیحات"
              size="small"
              value={state.description ? state.description : ""}
              onChange={(evt) => {
                setState({
                  ...state,
                  id: detailRes.id,
                  description: evt.target.value,
                });
              }}
              variant="outlined"
            />
            <Button
              sx={{ width: "80px", mx: "auto" }}
              variant="contained"
              onClick={() => {
                if (opration.add) {
                  if (!state.cost) {
                    enqueueSnackbar("لطفا مبلغ را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  let model = state;
                  if (state.offerid) {
                    model.cost = 0;
                  }
                  AddWallet(model, () => {
                    setState({
                      ...state,
                      cost: 0,
                      description: undefined,
                      offerid: undefined,
                    });
                    setOpration({ ...opration, show: false });
                    props.callback();
                    getWalletByMobile(props.openDetail.mobile, (callback) => {
                      setDetailRes(callback);
                    });
                  });
                } else if (opration.subtract) {
                  if (!state.cost) {
                    enqueueSnackbar("لطفا مبلغ را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  SubtractWallet(state, () => {
                    setState({
                      ...state,
                      cost: 0,
                      description: undefined,
                    });
                    props.callback();
                    getWalletByMobile(props.openDetail.mobile, (callback) => {
                      setDetailRes(callback);
                    });
                    setOpration({ ...opration, show: false });
                  });
                }
              }}
            >
              ثبت
            </Button>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
